import { UnwrapRef, reactive, Ref } from '@vue/composition-api';
import { createContext } from '@berlin-front/common/composables/context';

export const AUTHCODE_RESEND_MESSAGE = '認証番号を再送しました。';
export const ATONE_SMS_DESCRIPTION_MESSAGE = 'SMSで届いた認証番号を入力してください。';
export const ATONE_LITE_SMS_DESCRIPTION_MESSAGE = 'SMS認証をすると、注文が確定されます。';

export type UseSmsAuthContextType = UnwrapRef<{
  useSmsAuth: (authCodeRef: Ref) => {
    description: string;
    phoneNumber: string;
    errorMessages: string[];
    infoMessages: string[];
    progress: number;
    isLoadingApi: boolean;
    /**
     * 直前の画面に戻る。
     * @returns
     */
    backToPrevious: undefined | (() => void);
    /**
     * 登録画面に戻る。
     * @returns
     */
    backToRegister: undefined | (() => void);
    onSubmitVerify: (code: string) => void;
    onSubmitResend: () => void;
  };
}>;
export const SmsAuthContext = createContext<UseSmsAuthContextType>(() => ({
  useSmsAuth: () =>
    reactive({
      description: '',
      phoneNumber: '',
      errorMessages: [],
      infoMessages: [],
      progress: 0,
      isLoadingApi: false,
      onSubmitVerify: () => {},
      onSubmitResend: () => {},
      backToPrevious: undefined,
      backToRegister: undefined,
    }),
}));
